import { api } from '../api/client';
import { API_COLLECTIONS_URL, API_ELEMENT_SETS_URL } from '../utils';

/**
 * What a marked card's elements are read from (KPR-1816): `{ cards, sets }`,
 * every card the source collection reads, global parents included, and the
 * element sets attached to them. Sets only add to the list, so a failed read
 * of them leaves the cards' own elements.
 */
export async function packageSourceCards(collectionId) {
	const [{ data: cards }, sets] = await Promise.all([
		api.get(`${API_COLLECTIONS_URL}/${encodeURIComponent(collectionId)}/cards`),
		api.get(API_ELEMENT_SETS_URL, { params: { collectionId } }).then(({ data }) => data).catch(() => []),
	]);
	return { cards: Array.isArray(cards) ? cards : [], sets: Array.isArray(sets) ? sets : [] };
}
